import { Card , CardContent, Typography, Box} from '@mui/material'
import React from 'react'
import Diversity3Icon from '@mui/icons-material/Diversity3';
import ErrorBoundary from '../../../../components/Common/ErrorBoundary';

const SingleValueKPI = ({ 
    handleModalShow,
    widgetData,
    widgetConfig
}) => {
    const { WidgetName = 'Single KPI', WidgetColor = '#4dd0e1', Datapoints, icon: Icon, Entity = '', WidgetID = ''} = widgetConfig || {}
    const { WidgetData = {} } = widgetData || {}
    const key = Datapoints && Datapoints.length > 0 ? Datapoints[0] : '';

    const value = WidgetData && WidgetData[key] ? WidgetData[key] : 0;

    const handleClick = () => {
    if (handleModalShow) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      const csvFileName = `${key.toLowerCase()}_data_${yyyy}-${mm}-${dd}`;

      if (Entity === 'Alert') {
            handleModalShow({}, Entity, WidgetID, csvFileName, WidgetName);
        } else if (Entity === 'Master') {
            handleModalShow({ EntityType: key }, Entity, WidgetID, csvFileName, WidgetName);
        }else if (Entity === 'Video Backup') {
            handleModalShow({ EntityType: key }, Entity, WidgetID, csvFileName, WidgetName);
        }
    }
}

  return (
    <ErrorBoundary>
     <div className='systemHealth m-0 WidgetPadding p-0' key={`widget-${WidgetID}`}>
      <Box sx={{ height: 8, backgroundColor: WidgetColor, borderTopLeftRadius: 8, borderTopRightRadius: 8 }} />
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          {Icon && <Icon sx={{ color: WidgetColor, mr: 1 }} />}
          <h5 className='singleKpiText'>{WidgetName}</h5>
        </Box>
        <h3 className='singleKpiText' style={{ cursor: handleModalShow ? 'pointer' : 'default' }} onClick={handleClick}>
          {value}
        </h3>
      </CardContent>
    </div>
    </ErrorBoundary>
  )
}

export default SingleValueKPI